/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each segment's share of the total is calculated automatically and appears in the tooltip.`)
};

const es_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La proporción del total de cada segmento se calcula automáticamente y aparece en la información emergente.`)
};

const de_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Anteil jedes Segments am Gesamtwert wird automatisch berechnet und erscheint im Tooltip.`)
};

const nl_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Het aandeel van elk segment in het totaal wordt automatisch berekend en verschijnt in de tooltip.`)
};

const fr_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La part de chaque segment dans le total est calculée automatiquement et apparaît dans l'infobulle.`)
};

const it_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La quota di ciascun segmento sul totale viene calcolata automaticamente e appare nel tooltip.`)
};

const pt_br2_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A participação de cada segmento no total é calculada automaticamente e aparece no tooltip.`)
};

const pt_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A fração de cada segmento no total é calculada automaticamente e aparece na dica.`)
};

const ja_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各セグメントの全体に対する割合は自動的に計算され、ツールチップに表示されます。`)
};

const zh_donut_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会的。每个分段占总数的比例会自动计算并显示在提示框中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_a3", locale)
	if (locale === "en") return en_donut_faq_a3(inputs)
	if (locale === "es") return es_donut_faq_a3(inputs)
	if (locale === "de") return de_donut_faq_a3(inputs)
	if (locale === "nl") return nl_donut_faq_a3(inputs)
	if (locale === "fr") return fr_donut_faq_a3(inputs)
	if (locale === "it") return it_donut_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_a3(inputs)
	if (locale === "pt") return pt_donut_faq_a3(inputs)
	if (locale === "ja") return ja_donut_faq_a3(inputs)
	return zh_donut_faq_a3(inputs)
};